import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Accordion } from "@/components/ui/accordion";
import { FishingHours } from './sections/FishingHours';
import { FishingSeasons } from './sections/FishingSeasons';
import { SpeciesLimits } from './sections/SpeciesLimits';
import { YouthRegulations } from './sections/YouthRegulations';
import { BoatRestrictions } from './sections/BoatRestrictions';
import { WatercraftInspections } from './sections/WatercraftInspections';
import { FishingAreas } from './sections/FishingAreas';
import { CampfireSafety } from './sections/CampfireSafety';
import { TrashCleanliness } from './sections/TrashCleanliness';
import { GeneralCamping } from './sections/GeneralCamping';
import { WildlifeGuidelines } from './sections/WildlifeGuidelines';
import { WildlifePrecautions } from './sections/WildlifePrecautions';
import { EmergencyInfo } from './sections/EmergencyInfo';
import { Firearms } from './sections/Firearms';
import { QuietHours } from './sections/QuietHours';
import { Phone, Calendar, Clock } from 'lucide-react';
export const FishingRegulationsContainer = () => {
  const [currentTab, setCurrentTab] = useState("fishing");
  return <Card className="bg-white shadow-md">
      <CardHeader className="bg-tribal-primary/10 border-b border-tribal-primary/20">
        <CardTitle className="text-tribal-secondary text-xl text-center">Fishing & Camping Rules and Regulations</CardTitle>
        <div className="text-tribal-secondary text-sm font-medium flex flex-col items-center justify-center mt-2">
          <div className="text-center font-semibold mb-2">Fish & Game Department:</div>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <div className="flex items-center gap-1">
              <Phone className="h-4 w-4 text-tribal-primary" />
              <span>208-759-3246</span>
            </div>
            <div className="flex items-center gap-1">
              <Calendar className="h-4 w-4 text-tribal-primary" />
              <span>Monday – Friday</span>
            </div>
            <div className="flex items-center gap-1">
              <Clock className="h-4 w-4 text-tribal-primary" />
              <span>8:00 am – 5:00 pm (MST)</span>
            </div>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-6">
        <Tabs value={currentTab} onValueChange={setCurrentTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2 mb-8">
            <TabsTrigger value="fishing">Fishing Regulations</TabsTrigger>
            <TabsTrigger value="camping">Camping Guidelines</TabsTrigger>
          </TabsList>
          
          <TabsContent value="fishing" className="space-y-6">
            <Accordion type="multiple" className="w-full space-y-4">
              <FishingHours />
              <FishingSeasons />
              <SpeciesLimits />
              <YouthRegulations />
              <BoatRestrictions />
              <WatercraftInspections />
              <FishingAreas />
              <Firearms />
            </Accordion>
          </TabsContent>
          
          <TabsContent value="camping" className="space-y-6">
            <Accordion type="multiple" className="w-full space-y-4">
              <GeneralCamping />
              <QuietHours />
              <CampfireSafety />
              <TrashCleanliness />
              <WildlifeGuidelines />
              <WildlifePrecautions />
              <Firearms />
            </Accordion>
          </TabsContent>
        </Tabs>
        
        {/* Emergency Information displayed outside of tabs */}
        <div className="mt-8 pt-8 border-t border-tribal-primary/20">
          <div className="bg-red-50 border border-red-200 rounded-md p-4">
            <EmergencyInfo standalone={true} />
          </div>
        </div>
      </CardContent>
    </Card>;
};